module.exports = __webpack_public_path__ + "static/media/json_insert_beispiele.811ac2c8.txt";